import {
  React,
  Component,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  SignButtonComponent,
} from 'imports/ComponentsImports';

import {
  CheckCircleIcon as ValidatedIcon,
  CancelIcon as NoValidatedIcon,
  EmptyCircleIcon as WaitingIcon,
} from 'imports/IconsImports';

import {
  PrimaryColor1,
  SuccessColor,
  FailureColor,
} from 'imports/DesignImports';

import {
  CircularProgress,
} from 'material-ui';

import 'styles/Tooltip.css';

class Validation extends Component {
  constructor(props){
    super(props);
    this.state = {
      who_sign: [],
      signatures: null,
      loading: true,
      error: false,
      open: false,
      decision: "waiting",
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
    };
  }

  componentDidMount(){
    this.getSignatures();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <p>Error al cargar validación.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <CircularProgress color='#9e9e9e' size={30} thickness={2} />
          </div>
      )
    }
    return (
      <div style={{display:'flex', width: '100%'}}>
        {this.printSignatures()}
      </div>
    );
  }

  getSignatures = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.signatures(this.props.project.id))
      .then((response) => {
        this.setState({
          signatures: response.data.signatures,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        this.setState({
          error: true,
          loading: false,
        })
      });
  }

  printSignatures = () => {
    var signatures = []
    this.state.signatures.forEach((signature, i) => {
      if(signature.decision === "signed"){
        signatures.push(
          <div key={i} style={{flex:1}}><ValidatedIcon style={{color:SuccessColor}} /><br />{this.printPosition(signature.user_position, signature.user_area_id)}</div>
        );
      }
      if(signature.decision === "nosigned"){
        signatures.push(
          <div key={i} style={{flex:1}}><NoValidatedIcon style={{color:FailureColor}} /><br />{this.printPosition(signature.user_position, signature.user_area_id)}</div>
        );
      }
      if(signature.decision === "waiting" || signature.decision === "next"){
        signatures.push(
          <div key={i} style={{flex:1}}><WaitingIcon style={{color:PrimaryColor1}} /><br />{this.printPosition(signature.user_position, signature.user_area_id)}</div>
        );
      }
    });
    return signatures;
  }

  printPosition = (position, area) => {
    if(position === "Líder de proyecto"){
      return <div className="tooltip">L.P.<span className="tooltiptext">Líder de Proyecto</span></div>
    }
    if(position === "Gerente de área" && area === 2){
      return <div className="tooltip">G.F.<span className="tooltiptext">Gerente de Finanzas</span></div>
    }
    if(position === "Gerente de área" && area !== 2){
      return <div className="tooltip">G.A.<span className="tooltiptext">Gerente de Área</span></div>
    }
    if(position === "Gerente Innovación"){
      return <div className="tooltip">G.I.<span className="tooltiptext">Gerente de Innovación</span></div>
    }
  }
}

export default withCookies(Validation);



// WEBPACK FOOTER //
// ./src/components/files/Validation.js